import { useMemo, useCallback } from "react";
import { Palette } from "lucide-react";
import { THEME_OPTIONS } from "../../../config/settings.config";
import {
  DARK_THEME_PRESETS,
  DEFAULT_PURPLE_PRESET,
  DEFAULT_THEME_KEY,
} from "../../../config/theme.presets";
import { useThemeColors } from "../../../DynamicThemeContext";
import ThemeSelector from "./ThemeSelector";

export default function SettingsSetupThemes({ data = [] }) {
  const { setColors } = useThemeColors();

  const selectedThemes = useMemo(() => {
    if (data.length) return data;
    return [localStorage.getItem("active_theme") || DEFAULT_THEME_KEY];
  }, [data]);

  const saveThemes = useCallback(
    (next) => {
      const active = next[0] || DEFAULT_THEME_KEY;
      const current = localStorage.getItem("active_theme") || DEFAULT_THEME_KEY;

      if (active === current) return;

      const preset =
        active === DEFAULT_THEME_KEY
          ? DEFAULT_PURPLE_PRESET
          : DARK_THEME_PRESETS[active];

      if (!preset) return;

      setColors(preset);
      localStorage.setItem("active_theme", active);
    },
    [setColors]
  );

  return (
    <ThemeSelector
      title="Setup Themes"
      icon={Palette}
      allItems={THEME_OPTIONS}
      selected={selectedThemes}
      setSelected={saveThemes}
    />
  );
}
